import React from 'react';
import styles from './Waves.module.css';

interface WavesProps {
  bars?: number;
}

export function Waves({ bars = 32 }: WavesProps) {
  return (
    <div className={styles.waves} aria-hidden="true">
      {Array.from({ length: bars }).map((_, i) => (
        <span
          key={i}
          className={styles.bar}
          style={{ animationDelay: `${(i % 16) * 0.07}s` }}
        />
      ))}
    </div>
  );
}
